import { useRBAC } from '@/contexts/RBACContext';
import type { IndustryType } from '@/types';

interface UserCompany {
  id: string;
  name: string;
  slug: string;
  is_internal: boolean;
  industry?: IndustryType;
  role: string;
}

interface UseUserCompanyReturn {
  company: UserCompany | null;
  companies: UserCompany[];
  loading: boolean;
}

/**
 * Hook to get the current user's company(s) with industry information
 * Used for industry-based filtering (e.g., NBC Universal → FILM → only FILM models)
 *
 * This hook is now a thin wrapper around useRBAC for backwards compatibility.
 * The actual RBAC data fetching happens in RBACContext to prevent flickering.
 */
export function useUserCompany(): UseUserCompanyReturn {
  const { company, companies, loading } = useRBAC();

  return {
    company: company,
    companies: companies,
    loading,
  };
}
